import axios from 'axios';
import { baseUrl, token } from '../../services/Apis';

export const DIRECCIONES_CONST = 'direcciones';

export const allDireccionesService = async (params) => {
  const res = await axios.get(`${baseUrl}/${DIRECCIONES_CONST}`, {
    headers: token({}),
    params,
  });
  return res;
};

export const saveDireccionesService = async (id, data) => {
  let res;
  if (id) {
    res = await axios.patch(`${baseUrl}/${DIRECCIONES_CONST}/${id}`, data, {
      headers: token({}),
    });
  } else {
    res = await axios.post(`${baseUrl}/${DIRECCIONES_CONST}`, data, {
      headers: token({}),
    });
  }
  return res;
};

export const oneDireccionesService = async (id) => {
  const res = await axios.get(`${baseUrl}/${DIRECCIONES_CONST}/${id}`, {
    headers: token({}),
  });
  return res;
};

export const deleteDireccionesService = async (id) => {
  const res = await axios.delete(`${baseUrl}/${DIRECCIONES_CONST}/${id}`, {
    headers: token({}),
  });
  return res;
};
